import InspectionStatus from "./InspectionStatus";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("reactContainer"));
root.render(<InspectionStatus
    eventName={window.eventName}
    eventCode={window.eventCode}
    projector={window.projector}
    columns={window.cols}
/>)
